import React from 'react'

const EditMaterialRecieptNote = () => {
  return (
    <div>EditMaterialRecieptNote</div>
  )
}

export default EditMaterialRecieptNote